// imageValidator.js
import { verifyImageSRC } from 'musora-content-services';

export default {
    install(app, options = {}) {
        // Use a MutationObserver to watch for images being added to the DOM
        if (typeof window !== 'undefined') {
            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    // Check for newly added nodes
                    if (mutation.addedNodes.length) {
                        mutation.addedNodes.forEach(node => {
                            // Check if the added node is an image
                            if (node.tagName === 'IMG') {
                                verifyImageSRC(node.getAttribute('src'));
                            }

                            // Also check any images inside the added node
                            if (node.querySelectorAll) {
                                const images = node.querySelectorAll('img');
                                images.forEach(img => {
                                    verifyImageSRC(img.getAttribute('src'));
                                });
                            }
                        });
                    }

                    // Check for attribute changes on existing images
                    if (mutation.type === 'attributes' &&
                        mutation.attributeName === 'src' &&
                        mutation.target.tagName === 'IMG') {
                        verifyImageSRC(mutation.target.getAttribute('src'));
                    }
                }
            });

            // Start observing once the DOM is ready
            document.addEventListener('DOMContentLoaded', () => {
                // Check existing images first
                document.querySelectorAll('img').forEach(img => {
                    verifyImageSRC(img.getAttribute('src'));
                });

                // Then observe future changes
                observer.observe(document.body, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['src']
                });
            });
        }
    }
}
